import React from 'react';

/**
 * A nudge across the top of a tab (closing reminder, shopping day, stale list, tidy-up,
 * voice tip). `action` is an optional button; `onDismiss` adds the ✕.
 */
export function Banner({ icon, className, action, onDismiss, dismissLabel, children }) {
  return (
    <div className={`do-reminder${className ? ` ${className}` : ''}`} role="status">
      <span className="do-reminder__icon">{icon}</span>
      <span className="do-reminder__txt">{children}</span>
      {action}
      {onDismiss && <button className="do-reminder__x" onClick={onDismiss} aria-label={dismissLabel}>✕</button>}
    </div>
  );
}
